/*Add the client list here that will have default layout as FBDMS*/
export const defaultClientList: any = ['FBDMS'];
